import { h } from "preact";

const LocationStr = ({ location }) => {
  const parts = [];
  if (location.venueName) {
    parts.push(location.venueName);
  }
  if (location.address) {
    parts.push(location.address);
  }

  return (
    <p>
      {parts.map((part, index) => {
        return (
          <span style={{ color: "#323232" }}>
            {part}
            {index < part.length - 1 ? <br /> : ""}
          </span>
        );
      })}
    </p>
  );
};
export default LocationStr;
